export enum AnnouncementFrameTypeEnum{
    FramePlus = 2,
    FrameFlame = 3
}